import React, { createContext, useContext, useMemo } from "react";
import { useAppContext } from "./AppContext";

export const StationsContext = createContext({
    stations: [],
    loadingStations: true,
    getStationName: () => "",
    getStationNamesFromIds: () => []
});

export const useStationsContext = () => useContext(StationsContext);

export const StationsContextProvider = ({ children }) => {
    const { customer, loadingCustomer } = useAppContext();

    const stationsData = useMemo(() => {

        // Extract stations safely
        const rawStations =
            customer?.stations ||
            customer?.customer?.stations ||
            [];

        console.log("StationsContext - rawStations:", rawStations);

        // id -> stationName map
        const stationMap = {};
        const stationIds = [];

        rawStations.forEach((station) => {
            if (station?.id && station?.stationName) {
                stationMap[station.id] = station.stationName;
                stationIds.push(station.id);
            }
        });

        // Convert single ID -> Enum Name
        const getStationName = (stationId) => {
            if (!stationId) return "";
            return stationMap[stationId] || "";
        };

        // Convert multiple IDs -> Enum Names (FOR API CALLS)
        const getStationNamesFromIds = (ids = []) => {
            return ids
                .map((id) => stationMap[id])
                .filter(Boolean); // remove undefined
        };

        return {
            stations: stationIds,              // For UI selection
            loadingStations: loadingCustomer,
            getStationName,                   // For display
            getStationNamesFromIds            // For API requests
        };

    }, [customer, loadingCustomer]);

    return (
        <StationsContext.Provider value={stationsData}>
            {children}
        </StationsContext.Provider>
    );
};